import PropTypes from 'prop-types';

import Breadcrumbs from 'components/Breadcrumbs';
import JobPostingOverview from 'components/JobPostingOverview';
import { JobPostingType } from 'lib/proptypes/jobPosting';
import { useTranslation } from 'next-i18next';
import { useMemo, useState } from 'react';
import Toggle from '@atoms/Toggle/Toggle';
import { useRouter } from 'next/router';

import DockToRightIcon from 'svg/dock-to-right.svg';
import HeadlineIcon from 'svg/headline.svg';
import { VIEW_MODES } from 'lib/constants';

export default function JobPostingsSplitView({ totalResults, jobPostings }) {
  const { query, pathname, push } = useRouter();

  const initialView = useMemo(() => query.view || VIEW_MODES.SPLIT, []);

  const [splitView, setSplitView] = useState(initialView);
  const { t } = useTranslation();

  const toggleView = () => {
    setSplitView(sv => {
      const targetView =
        sv === VIEW_MODES.SPLIT ? VIEW_MODES.LIST : VIEW_MODES.SPLIT;

      push({
        pathname,
        query: {
          ...query,
          view: targetView,
        },
      });

      return targetView;
    });
  };

  return (
    <div className="o-retain o-retain--wall">
      <div className="o-layout o-layout--justify-space-between o-layout--align-center">
        <Breadcrumbs
          links={[
            {
              label: t('jobPostingOverview.pageTitle'),
              href: '/vacatures',
            },
          ]}
        />

        <Toggle
          className="c-job-posting-list__toggle"
          value={splitView}
          options={[
            {
              label: t('layout.preview'),
              value: VIEW_MODES.SPLIT,
              Icon: DockToRightIcon,
            },
            {
              label: t('layout.list'),
              value: VIEW_MODES.LIST,
              Icon: HeadlineIcon,
            },
          ]}
          onChange={toggleView}
        />
      </div>

      <JobPostingOverview
        totalResults={totalResults}
        serverSideResults={jobPostings}
        splitView={splitView}
      />
    </div>
  );
}

JobPostingsSplitView.propTypes = {
  totalResults: PropTypes.number,
  jobPostings: PropTypes.arrayOf(JobPostingType),
};
